import React from 'react';
import { createContext } from 'react';

type ListenerCallback = (details: any) => void;

export enum DispatcherEvents {
  SCHOOL_DETAILS_CHANGE = 'SCHOOL_DETAILS_CHANGE',
  OFFLINE_POPUP_OPEN = 'OFFLINE_POPUP_OPEN',
  OFFLINE_POPUP_CLOSE = 'OFFLINE_POPUP_CLOSE',
  APP_BACKDROP_SHOWN = 'APP_BACKDROP_SHOWN',
  USER_DATA_CHANGE = 'USER_DATA_CHANGE',
}

class Dispatcher {
  private events: {
    [dict_key: string]: {
      listeners: ListenerCallback[];
    };
  };

  constructor() {
    this.events = {};
  }

  addListener(event: DispatcherEvents, callback: ListenerCallback) {
    if (!this.events[event]) {
      this.events[event] = {
        listeners: [],
      };
    }

    this.events[event].listeners.push(callback);
  }

  removeListener(event: DispatcherEvents, callback: ListenerCallback) {
    if (!this.events[event]) {
      return false;
    }

    this.events[event].listeners = this.events[event].listeners.filter(
      (listener: ListenerCallback) => listener !== callback
    );
  }

  dispatch(event: DispatcherEvents, details: any) {
    if (!this.events[event]) {
      return false;
    }

    this.events[event].listeners.forEach((listener: ListenerCallback) => {
      listener(details);
    });
  }
}

const eventDispatcher = new Dispatcher();

export const EventDispatcherContext = createContext<Dispatcher>(eventDispatcher);

export const EventDispatcherProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EventDispatcherContext.Provider value={eventDispatcher}>
      {children}
    </EventDispatcherContext.Provider>
  );
};
